import './ValidatorForm'



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/validation/script.js